// Lumin LP smooth scroll for #anchor links
// Handles both click events and page load with hash in URL

(function() {
  var OFFSET = 100; // offset for sticky header

  function scrollToAnchor(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    window.scrollTo({ top: top, behavior: 'smooth' });
    return true;
  }

  // Handle clicks on all #anchor links
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var hash = link.getAttribute('href').slice(1);
    if (!hash) return;
    if (scrollToAnchor(hash)) {
      e.preventDefault();
      history.pushState(null, '', '#' + hash);
    }
  });

  // Handle page load with hash in URL
  function handleHashOnLoad() {
    var hash = window.location.hash.slice(1);
    if (!hash) return;
    // Wait for page to fully render
    setTimeout(function() {
      scrollToAnchor(hash);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleHashOnLoad);
  } else {
    handleHashOnLoad();
  }
})();
